import { createContext, useContext, useRef } from 'react';
import { Controller, interpolate } from 'react-spring';

import { AnimateState } from '../animate';

const AnimateContext = createContext({
    state: AnimateState.Default,

    controller: new Controller()
        .update({
            alpha: 0,

            config: {
                tension: 210,
                friction: 0,
                mass: 1.5,
                clamp: true,
            },

            immediate: false,
        })
        .start(),
});

export default function useAnimate() {
    const animate = useContext(AnimateContext);

    return {
        animateState: animate.state,

        setAnimateState: (state: AnimateState) => {
            animate.state = state;
        },

        animate: <T>(onUpdate: (alpha: number) => Record<number, T>) => {
            const values = animate.controller.getValues<{ alpha: number }>();
            return values.alpha.interpolate((alpha) => {
                const states = onUpdate(alpha);
                const value = states[animate.state];
                return value != null ? value : states[AnimateState.Default];
            });
        },

        setAnimate: (alpha = 0, immediate = false) => {
            animate.controller.update({ alpha, immediate });
            animate.controller.start();

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            animate.controller.getValues().alpha.flush();
        },
    };
}
